import { type CookieConsentValue } from "./consent";

type GtagConsentType = "granted" | "denied";

// Set consent parameters
function setConsent(
  action: string,
  adStorage: GtagConsentType,
  adUserData: GtagConsentType,
  adPersonalization: GtagConsentType,
  analyticsStorage: GtagConsentType,
  functionalityStorage: GtagConsentType
) {
  gtag("consent", action, {
    ad_storage: adStorage,
    ad_user_data: adUserData,
    ad_personalization: adPersonalization,
    analytics_storage: analyticsStorage,
    functionality_storage: functionalityStorage,
  });
}

// Call to deny all parameters by default
export function setDefaultConsent() {
  setConsent("default", "denied", "denied", "denied", "denied", "denied");
}

export const updateGtagConsent = (
  functional: CookieConsentValue,
  performance: CookieConsentValue,
  targeting: CookieConsentValue
) => {
  if (functional === "true" && performance === "true" && targeting === "true")
    return allConsentGranted();
  if (functional === "true" && performance === "false" && targeting === "false")
    return functionalConsentOnlyGranted();
  if (functional === "true" && performance === "true" && targeting === "false")
    return performanceConsentGranted();
  if (functional === "true" && performance === "false" && targeting === "true")
    return targetingConsentGranted();
  else return allConsentDeniedOnUpdate();
};

// Call to deny all parameters on update
export function allConsentDeniedOnUpdate() {
  setConsent("update", "denied", "denied", "denied", "denied", "denied");
}

// Call to grant all parameters on update
export function allConsentGranted() {
  setConsent("update", "granted", "granted", "granted", "granted", "granted");
}

// Call to grant performance parameters on update
export function functionalConsentOnlyGranted() {
  setConsent("update", "denied", "denied", "denied", "denied", "granted");
}

// Call to grant performance parameters on update
export function performanceConsentGranted() {
  setConsent("update", "denied", "denied", "denied", "granted", "granted");
}

// Call to grant targeting parameters on update
export function targetingConsentGranted() {
  setConsent("update", "granted", "granted", "granted", "denied", "granted");
}
